import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { UserProvider } from './user-provider';
import { configureErrorHandling } from './utilities/errors';
import { BrowserRouter } from 'react-router-dom';
// Expose version for debugging - check with: __VIRTIUS_VERSION__
window.__VIRTIUS_VERSION__ = require('../package.json').version;

// Dev-only: Remote reload via BroadcastChannel
// Usage: Open console in any tab and run: reload() or reloadAll()
if (process.env.NODE_ENV === 'development') {
  const reloadChannel = new BroadcastChannel('virtius-reload');
  reloadChannel.onmessage = (e) => {
    if (e.data === 'reload') {
      window.location.reload();
    }
  };
  // Reload all tabs (including this one)
  window.reloadAll = () => {
    reloadChannel.postMessage('reload');
    window.location.reload();
  };
  // Reload other tabs only
  window.reloadOthers = () => {
    reloadChannel.postMessage('reload');
  };
  // Alias for convenience
  window.reload = () => window.location.reload();
}

// Secret hotkeys to switch between prod and localhost
// Ctrl+Shift+L = reload in place (same tab)
// Ctrl+Option+Shift+L = open in new tab
document.addEventListener('keydown', (e) => {
  if (e.ctrlKey && e.shiftKey && e.key === 'L') {
    e.preventDefault();
    const path =
      window.location.pathname + window.location.search + window.location.hash;
    const isLocalhost = window.location.hostname === 'localhost';
    const targetUrl = isLocalhost
      ? `https://virti.us${path}`
      : `https://localhost:3001${path}`;

    if (e.altKey) {
      window.open(targetUrl, '_blank');
    } else {
      window.location.href = targetUrl;
    }
  }
});

configureErrorHandling();

ReactDOM.render(
  <Provider store={store}>
    <UserProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </UserProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
